import React, { useState, useRef, useEffect } from 'react';
import { CSVLink } from 'react-csv';
import { usePortfolioExports } from './usePortfolioExports';
import { Select, Space, Row, Col, Typography, Card, Divider } from 'antd';
import Button from '@mui/material/Button';
import Spreadsheet from '../../components/Spreadsheet';

const { Option } = Select;

const PortfolioExport = ({ portfolio }) => {
    const { csvData, downloadToAdvyzon, downloadToFidelity, downloadToDefault } = usePortfolioExports();
    const [selectedFormat, setSelectedFormat] = useState('default');
    const [fileName, setFileName] = useState('portfolio_export.csv');
    const csvLink = useRef(null);

    // Handler for changing formats and formatting the portfolio accordingly
    const handleFormatChange = (value) => {
        setSelectedFormat(value);
        if (value === 'advyzon') {
            downloadToAdvyzon(portfolio);
        } else if (value === 'fidelity') {
            downloadToFidelity(portfolio);
        } else {
            downloadToDefault(portfolio);
        }
    };
    useEffect(() => {
        handleFormatChange(selectedFormat);
    })

    return (
        <Card className={'gapless-x'}
              bordered={false}
              title={<Typography.Title level={3}>Portfolio Export</Typography.Title>}
        >

            <Row className={'px-3'} gutter={32}>
                <Col>
                    <Select
                        defaultValue="default"
                        onChange={handleFormatChange}
                        style={{ width: 200, marginBottom: 20 }}
                    >
                        <Option value="default">Default Format</Option>
                        <Option value="advyzon">Advyzon</Option>
                        <Option value="fidelity">Fidelity</Option>
                    </Select>
                </Col>
                <Col>
                    <Button variant={'contained'} color={'info'} onClick={() => csvLink.current.link.click()}>
                        Download CSV
                    </Button>
                </Col>
            </Row>
            {/* Table Preview */}
            <Spreadsheet rows={csvData} />

            <CSVLink
                data={csvData}
                filename={fileName}
                ref={csvLink}
                target="_blank"
                style={{ display: 'none' }}
            />
        </Card>
    );
};

export default PortfolioExport;
